
import { defineComponent } from 'vue'
import LoginForm from '@/components/forms/LoginForm.vue'

export default defineComponent({
    name: 'Home',
    components: { LoginForm }
})
